import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { media } from 'utilities/styled'

import Overlay from 'components/molecules/overlay'
import MediaForm from 'components/organisms/media-form'

const StyledOverlay = styled(Overlay)`
  .child-container {
    display: flex;
    flex-direction: column;
  }
`

const StyledMediaForm = styled(MediaForm)`
  width: 100%;
  display: flex;
  flex-direction: ${({ $optimizeMobileLayout }) =>
    $optimizeMobileLayout ? 'column' : 'row'};
  align-items: ${({ $optimizeMobileLayout }) =>
    $optimizeMobileLayout ? 'stretch' : 'center'};
  justify-content: ${({ $optimizeMobileLayout }) =>
    $optimizeMobileLayout ? 'flex-start' : 'space-between'};

  ${({ $optimizeMobileLayout }) =>
    $optimizeMobileLayout &&
    media.desktop`
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    `}
`

function SelectMediaOverlay({
  closeOverlay,
  title,
  text,
  onSubmitText,
  onSubmit,
  items,
  type,
  exclusiveSelect,
  disabled,
  allowEmptySelect,
  emptyStateText,
  optimizeMobileLayout,
}) {
  return (
    <StyledOverlay
      close={closeOverlay}
      icon="media"
      count={items.length}
      title={title}
      text={text}
    >
      <StyledMediaForm
        level="standard"
        uploadButtonText={onSubmitText}
        onSelect={onSubmit}
        items={items}
        type={type}
        exclusiveSelect={exclusiveSelect}
        disabled={disabled}
        allowEmptySelect={allowEmptySelect}
        emptyStateText={emptyStateText}
        $optimizeMobileLayout={optimizeMobileLayout}
      />
    </StyledOverlay>
  )
}

SelectMediaOverlay.propTypes = {
  closeOverlay: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  onSubmitText: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      src: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['image', 'document']).isRequired,
    }),
  ).isRequired,
  type: PropTypes.oneOf(['images', 'documents']),
  exclusiveSelect: PropTypes.bool,
  disabled: PropTypes.bool,
  allowEmptySelect: PropTypes.bool,
  emptyStateText: PropTypes.string,
  optimizeMobileLayout: PropTypes.bool,
}

SelectMediaOverlay.defaultProps = {
  type: 'images',
  text: undefined,
  exclusiveSelect: false,
  disabled: false,
  allowEmptySelect: false,
  emptyStateText: null,
  optimizeMobileLayout: false,
}

export default SelectMediaOverlay
